import { Button } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import { TableSortLabel } from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import { IconFlagCA, IconFlagIN, IconFlagUS } from "material-ui-flags";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import http from "../services/httpService";
import {
  getDate,
  editEFG,
  searchFilter,
  handleSort,
} from "../utils/varialbles";
import SearchBar from "material-ui-search-bar";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: 5,
  },
  button: {
    borderRadus: 10,
  },
  detailsButton: {
    backgroundColor: "#fff",
    color: "#3c52b2",
    "&:hover": {
      backgroundColor: "#3c52b2",
      color: "#fff",
    },
    borderColor: "#3c52b2",
  },
}));
const columns = [
  { id: "Question", label: "Questions", minWidth: 170 },
  { id: "Section", label: "Section", minWidth: 150 },
  { id: "Type", label: "Type", minWidth: 150 },
  { id: "Status", label: "Status", minWidth: 150, format: "boolean" },
  { id: "Options", label: "Options", minWidth: 150, fromat: "Array" },
  { id: "Edit", label: "Edit", minWidth: 150 },
];

function EfgOverView() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState([]);
  const [searched, setSearched] = React.useState("");
  const [orignalRows, setOriginalRows] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState("cust__createddt");
  const [order, setOrder] = React.useState("asc");
  const [dialog, setDialog] = useState(false);
  const [otpField, setotpField] = useState("");
  const [tablecurrentrow, settablecurrentrow] = useState({});

  const requestSearch = (searchedVal) => {
    let rowsTemp = [...orignalRows];

    setPage(0);
    setRows(searchFilter(searchedVal, rowsTemp));
  };

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };
  let history = useHistory();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleRequestSort = (e, property, format) => {
    let isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    let tempRows = [...rows];
    let finalRows = handleSort(property, format, tempRows, isAsc);

    setRows(finalRows);
    setPage(0);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleOTPRequest = (row) => {
    setDialog(true);
    settablecurrentrow(row);

    const actionobj = {
      Action: "Edit Question",
      Question: row.Question,
      Section: "EFG Questions",
    };

    if (actionobj.Question.length > 0) {
      http
        .post("/verification_view", actionobj)
        .then((res) => {
          toast.success("OTP Sent Successfully!");
        })
        .catch((err) => {
          toast.error("OTP Request Failed!");
        });
    }
  };

  const editEFGButton = (e) => {
    history.push({
      pathname: editEFG,
      state: tablecurrentrow,
      otp: otpField,
    });
  };

  const handleOTP = (e) => {
    setotpField(e.target.value);
    // console.log(otpField, "OTP");
  };

  useEffect(() => {
    toast.loading("Please wait...");

    http
      .get("/efglist")
      .then((response) => {
        toast.dismiss();
        if (response && response.data && response.data.Data) {
          setOriginalRows(response.data.Data);
          setRows(response.data.Data);
          setPage(0);
        }
      })
      .catch((error) => {});
  }, []);

  return (
    <div className={classes.root}>
      <Paper className={classes.root}>
        <SearchBar
          value={searched}
          onChange={(searchVal) => requestSearch(searchVal)}
          onCancelSearch={() => cancelSearch()}
          style={{ height: "auto", padding: "5px 0" }}
        />
        <TablePagination
          rowsPerPageOptions={[5, 10, 15, 25, 50, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                    className="prospect_table"
                  >
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : "asc"}
                      onClick={(e) =>
                        handleRequestSort(e, column.id, column.format)
                      }
                    >
                      {column.label}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length !== 0 ? (
                <>
                  {rows
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={index + "a"}
                          className="prospecttable"
                        >
                          {columns.map((column, index) => {
                            let value = row[column.id];
                            if (value && Array.isArray(value)) {
                              value = value.join(",");
                            }
                            return (
                              <TableCell
                                key={index + column.id}
                                align={column.align}
                              >
                                {column.format && typeof value === "number" ? (
                                  column.format(value)
                                ) : column.format === "Date" ? (
                                  getDate(value)
                                ) : column.operation &&
                                  column.operation === "concate" ? (
                                  value + column.operand + row[column.with]
                                ) : column.format === "boolean" &&
                                  row[column.id] ? (
                                  "Yes"
                                ) : column.format === "boolean" &&
                                  !row[column.id] ? (
                                  "No"
                                ) : column.id === "Edit" ? (
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    // onClick={(e) => editEFGButton(e, row)}
                                    onClick={(e) => handleOTPRequest(row)}
                                  >
                                    {column.id}
                                  </Button>
                                ) : value ? (
                                  value
                                ) : (
                                  "N/A"
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                </>
              ) : (
                <TableCell
                  colspan="7"
                  style={{ "text-align": "center", margin: "10px 0px" }}
                >
                  Records Not Available
                </TableCell>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Dialog
          open={dialog}
          onClose={(e) => setDialog(false)}
          aria-labelledby="draggable-dialog-delete"
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-delete">
            Edit Question
          </DialogTitle>
          <DialogContent>
            <span>Are you sure you want to edit this Question?</span>
            <p>Enter OTP</p>

            <input placeholder="OTP" onChange={handleOTP}></input>
          </DialogContent>
          <DialogActions>
            <Button onClick={(e) => setDialog(false)} variant="outlined">
              No
            </Button>
            <Button
              autoFocus
              onClick={editEFGButton}
              variant="contained"
              color="primary"
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </div>
  );
}
export default EfgOverView;
